// @flow

import StateListenerRegistry from '../../../../react/features/base/redux/StateListenerRegistry';

StateListenerRegistry.register(
    /* selector */ state => state['features/base/devices'].availableDevices.videoInput,
    /* listener */ videoDevices => {
        if (APP.wildix.wizy && APP.conference.wCanUpdateList) {
            APP.wildix.wizy.getDeviceList();
            APP.conference.wCanUpdateList = false;
        }
    });
